import { mainAxios as axios } from "./axios";
// Lists
export const getPermissions = async () => {
  return axios.get("/permissions");
};
export const getPermissionsUser = async ({ user_id }) => {
  return axios.get(`/permissions/${user_id}`);
};
export const updatePermission = async ({ permission_name, user_id, value }) => {
  return axios.put(`/permissions/${permission_name}/${user_id}`, { value });
};
export const deletePermission = async ({ permission_name, user_id }) => {
  return axios.delete(`/permissions/${permission_name}/${user_id}`);
};
export const subscribeUser = async ({ user_id, end_date }) => {
  return axios.post(`/subscriptions/subscribe/${user_id}`, {
    end_date,
  });
};
export const unsubscribeUser = async ({ user_id }) => {
  return axios.delete(`/subscriptions/unsubscribe/${user_id}`);
};
export const addToOrg = async ({ user_id, organization_id }) => {
  return axios.post(`/admin/organizations/${organization_id}/join/${user_id}`);
};
export const addToTeam = async ({ user_id, team_id }) => {
  return axios.post(`/admin/teams/${team_id}/join/${user_id}`);
};
export const removeFromOrg = async ({ user_id, organization_id }) => {
  return axios.delete(
    `/admin/organizations/${organization_id}/leave/${user_id}`,
  );
};
export const removeFromTeam = async ({ user_id, team_id }) => {
  return axios.delete(`/admin/teams/${team_id}/leave/${user_id}`);
};
export const removeFromReseller = async ({ user_id, reseller_id }) => {
  return axios.delete(`/resellers/${reseller_id}/users/${user_id}`);
};

export const getTeams = async () => {
  return axios.get(`/admin/teams`);
};
export const getOrgs = async () => {
  return axios.get(`/admin/organizations`);
};

export const getResellers = async () => {
  return axios.get(`/admin/resellers/domains`);
};

export const changeUserReseller = async ({
  user_id,
  current_reseller_id,
  new_reseller_id,
  level,
}) => {
  return axios.put(
    `/admin/users/${user_id}/change/reseller/${current_reseller_id}/to/${new_reseller_id}`,
    {
      level: level,
    },
  );
};

export const changeUserTeamLevel = async ({ user_id, team_id, level }) => {
  return axios.put(`/teams/${team_id}/level/${user_id}`, {
    level: level,
  });
};

export const changeUserOrganizationLevel = async ({
  user_id,
  organization_id,
  level,
}) => {
  return axios.put(`/organizations/${organization_id}/level/${user_id}`, {
    level: level,
  });
};

// Allowed field_name for filter/sort:
// id, last_name, first_name, email, source, created_on, last_activity, in_a_reseller, number_integrations_email, number_integrations_linkedin, number_model, number_programmations, number_contact_list, sum_billed.
// Only for filter: tag_id

export const getAllUsers = async ({
  per_page,
  sort,
  filter,
  query,
  date_range,
  page,
}) => {
  return axios.post(
    `/admin/users/list/search${page > 1 ? "/page/" + page : ""}`,
    {
      query,
      date_range,
    },
    {
      params: {
        options: JSON.stringify({
          per_page,
          filter,
          sort,
        }),
      },
    },
  );
};
export const getStatsAllUsers = async ({ date_range, filter }) => {
  return axios.post(`/admin/statistics/users`, {
    date_range,
    filter,
  });
};
export const deleteBounces = async ({ emails }) => {
  return axios.delete(`/admin/emails/bounce`, {
    data: {
      emails,
    },
  });
};

export const getEnrichUsageAdmin = async ({ date_range, user_id }) => {
  return axios.post(`/admin/enrich/usage`, {
    date_range,
    user_id,
  });
};

export const getEnrichUsage = async ({ date_range }) => {
  return axios.post(`/enrich/usage`, {
    date_range,
  });
};
